export default {
  'component.statistics.title': 'Statistikk',
  'component.statistics.description': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam mollis nec enim ac blandit. Nullam eget posuere augue. Sed sed bibendum orci. In pretium malesuada tortor, eu aliquet purus tempor quis. Etiam sit amet urna ac est tincidunt sagittis sit amet at quam. ',
  'component.statistics.marketing': 'Markedsføring',
  'component.statistics.finnno': 'Finn.no Stats',
  'component.statistics.finnno.placeholder': 'Angi Antall Klikk',
  'component.statistics.salesstats': 'Salgsstatistikk',
  'component.statistics.inspection': 'Befaringsapplikasjon',
  'component.statistics.newassignment': 'Oppdrag',
  'component.statistics.sale': 'Salg',
  'component.statistics.omsetning': 'Omsetning (nr. i tusen)',
}
